import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import generateId from 'src/lib/generateId';
import * as sharedTypes from 'src/actions/shared/sharedTypes';
import Toast, { ToastType } from 'src/models/Toast';

const initialState: Toast[] = [];

const toastSlice = createSlice({
  name: 'toasts',
  initialState,
  reducers: {
    showToast(state, action: PayloadAction<Toast>) {
      state.push(action.payload);
    },
  },
});

const { showToast } = toastSlice.actions;

const showTypedToast: sharedTypes.AppThunk = (message: string, type: ToastType) => async dispatch => {
  dispatch(
    showToast({
      id: generateId(),
      message: message,
      type: type,
    })
  );
};

const toastSuccess = (message: string) => showTypedToast(message, ToastType.SUCCESS);
const toastInfo = (message: string) => showTypedToast(message, ToastType.INFO);
const toastWarn = (message: string) => showTypedToast(message, ToastType.WARN);
const toastError = (message: string) => showTypedToast(message, ToastType.ERROR);

export { toastSuccess, toastInfo, toastWarn, toastError };
export default toastSlice;
